import { environment } from '../environment';
export function shareAbdooLink(userId) {
    navigator.share({ url: `${environment.employeeFrontendUrl}?share=${userId}` });
}
